import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-plantlist',
  templateUrl: './plantlist.component.html',
  styleUrls: ['./plantlist.component.scss']
})
export class PlantlistComponent implements OnInit {
  simulatedPlantList: any;

  constructor(private cstemapi: CstemapiService, private auth: AuthService, private myRoute: Router) { }

  ngOnInit() {
    this.getSimulatedPlantList();
  }

  getSimulatedPlantList() {
    var dObj = {
      userId: this.auth.getUserId()
    };

    this.cstemapi.cstemAPI(dObj).GetSimulatedPlantList.subscribe(data => { /* designed api, please change with the actual url */

      let resData: any = data;
      // console.log(resData)
      if (resData.statusCode == 'S001') {
        this.simulatedPlantList = resData.plantDetails;
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  selectedPlant(pdata) {
    // console.log(pdata)
    this.cstemapi.Swal.fire({
      title: 'Are you sure?',
      text: 'You want to select this plant!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, select it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.auth.savePlantId(pdata.plantId);
        this.myRoute.navigate(['/outputs'])
      }
    })
  }

}
